export default __webpack_public_path__ + "static/media/screenBlock18.b76db892.jpg";